import { Component, ElementRef, ViewChild } from '@angular/core';

import { Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';

import { FormControl } from '@angular/forms';
import { AuthServiceGuest } from '../../../services/AuthServiceGuest';
import { CurrentUser } from '../../../dataTypes/CurrentUser';
import { OnInit } from '@angular/core';
import { OnDestroy } from '@angular/core';
import { Input } from '@angular/core';



@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit, OnDestroy{

  public user: CurrentUser;
  isExpanded = false;

  public _authorized$: Observable<boolean>;
  public _userName: string;

  public _activeLink: string;
  //public _sitesList: SiteModel[];
  //public _selectedSite: SiteModel;
  sitesCtrl: FormControl;
  options: string[];
  
 // @ViewChild(MatAutocompleteTrigger) _auto: MatAutocompleteTrigger;

  //---------
  @ViewChild('navMenu', { static: true }) navMenu: ElementRef;

  @Input() isMobileNavInput: boolean;
  //-----------

  constructor( private _router: Router, public _AuthService: AuthServiceGuest) {
    this._router.events.subscribe((event) => {

      let self = this;
      this.sitesCtrl = new FormControl();


      if (event) {
        if (event instanceof NavigationEnd) {
       
          self._activeLink = self._router.url;
          console.debug('NavMenuComponent event ' + self._activeLink);
        }
      }
    });
  }
   
  ngOnInit(): void {

    const self = this;
   
   self.user = self._AuthService.getUserInfo();

    //------------
    console.debug('NavMenuComponent user CompanyCode: ' + self.user.CompanyCode);
    //------------
   
  }

  ngOnDestroy(): void {
    // Clean up resources here
    // Unsubscribe from observables, cancel timers, etc.
  }


  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
  OnLogout() {
    const self = this;
    console.log('*** Logout to proceed ***');

    self._AuthService.logout();
  }
}
